import React from 'react'

const Etape = ({ showSteps, steps, afficheMin, path }) => {
     // Si "showSteps" est false (ou undefined, null, etc.) OU si le tableau "steps" est vide
    // alors ne rien afficher (retourner null arrête le rendu du composant), ne rien afficher à l’écran.
    if (!showSteps || steps.length === 0) return null
    
    return (
        <>
            <div>
                <h2 className="text-xl font-semibold mb-2">
                Étapes de l'algorithme de Dantzig <span style={{ fontWeight: 'lighter' }}>({afficheMin ? 'Minimisation' : 'Maximisation'})</span>
                </h2>
                <div className="dantzig-steps-container">
                <div className="steps-header">
                    <div className="step-column"> </div>
                    <div className="calculations-column">Calculs</div>
                    <div className="results-column">Résultats</div>
                </div>

                <div className="steps-content">
                    {/* Étape d'initialisation */}
                    <div className="step-row">
                    <div className="step-column">
                        <strong>Initialisation</strong>
                    </div>
                    <div className="calculations-column">
                        λ({steps[0].startNodeName}) = 0<br />
                        {steps[0].ensembleE}
                    </div>
                    <div className="results-column"></div>
                    </div>

                    {/* Séparateur */}
                    <div className="step-separator"></div>

                    {/* Étapes suivantes */}
                    {steps.slice(1).map((step, index) => (
                    <div key={index} className="step-row">
                        <div className="step-column">
                        <strong>k = {step.step}</strong>
                        </div>
                        <div className="calculations-column">
                        {step.connections.map((conn, connIndex) => (
                            <div key={connIndex}>
                            <span style={{ paddingRight: '30px' }}>V({conn.fromName}, {conn.toName})</span>
                            <span>
                                λ({conn.toName}) = λ({conn.fromName}) + V({conn.fromName}, {conn.toName}) =
                                {step.lambda[conn.from]} + {conn.weight} = {conn.calculatedLambda}
                            </span>
                            </div>
                        ))}
                        </div>
                        <div className="results-column">
                        {step.isMaximization ? 'max' : 'min'}:
                        <span style={{ color: 'red' }}>
                            λ({step.nodeMarked}) = {step.isMaximization ? step.maxLambda : step.minLambda}
                        </span><br />
                        {step.ensembleE}
                        </div>
                    </div>
                    ))}

                    {/* Résultat final - version modifiée */}
                    

{/* Résultat final - version modifiée pour chemins multiples */}
{/* Résultat final - version modifiée pour chemins multiples */}
<div className="final-result">
  <div className="step-column">
    <strong>{afficheMin ? 'Chemin minimal' : 'Chemin maximal'}</strong>
  </div>
  <div className="results-column" style={{ gridColumn: "2 / span 2" }}>
    {/* Vérifier s'il y a plusieurs chemins */}
    {steps.length > 0 && steps[steps.length - 1].hasMultiplePaths ? (
      <div>
        <div style={{ marginBottom: '10px', fontWeight: 'bold', color: 'blue' }}>
          Plusieurs chemins {afficheMin ? 'minimaux' : 'maximaux'} trouvés :
        </div>
        {(steps[steps.length - 1].allMinimalPaths || steps[steps.length - 1].allMaximalPaths)?.map((pathNodes, index) => (
          <div key={index} style={{ marginBottom: '5px' }}>
            <strong>Chemin {index + 1}:</strong> {pathNodes.map(node => node.name).join(' → ')}
          </div>
        ))}
      </div>
    ) : (
      <div>
        {path.map(node => node.name).join(' → ')}
      </div>
    )}
  </div>
</div>
                </div>
                </div>
            </div>
        </>
    )
}

export default Etape